/** ISO UTC → HH:MM по Москве: подпись «Новые жетоны — в 00:00 МСК» верна в любом поясе браузера. */
export function formatMoscowTime(iso: string): string {
  if (Number.isNaN(Date.parse(iso))) return '00:00';
  try {
    return new Date(iso).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow' });
  } catch {
    return '00:00';
  }
}

/** ISO UTC → локальное HH:MM (для РФ-браузера это 00:00 МСК — момент сброса лимита). */
export function formatResetTime(iso: string): string {
  try {
    return new Date(iso).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '00:00';
  }
}
